//don't add imports here, imported directly from main entry.
export const getMadeForFontUrl = (scriptsDomainUrl) => {
    return `${scriptsDomainUrl}unpkg/@wix/wix-fonts@1.11.0/madefor.min.css`;
};
